<template>
  <div>
    <div class="profile__charts__container">
      <div class="sales_report__container">
        <ReportFilter report-type="payments" report-filename="PaymentsReport" />
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import { DATE_FORMAT_YYYY_MM_DD } from "@/constants";
import { format } from "date-fns";
import ReportFilter from "@/components/reports/ReportFilter.vue";

export default {
  name: "PaymentReport",
  components: { ReportFilter },

  data() {
    const min_from = format(new Date(2025, 0, 1), DATE_FORMAT_YYYY_MM_DD);

    const max_from = format(new Date(), DATE_FORMAT_YYYY_MM_DD);

    const clients = [{ id: "", name: "All Clients" }];

    const users = [{ id: "", name: "All Users" }];

    const usersText = "All Users";

    const clientsText = "All Clients";

    const defaultRequestsByClientOptionsParams = {
      from: min_from,
      to: max_from,
      loading: false,
      users,
      usersText,
      clients,
      clientsText,
    };

    return {
      isLoadingUsers: false,
      salesReportParams: {
        min_from: min_from,
        max_from: max_from,
        from: min_from,
        to: max_from,
        users,
        usersText,
        clients,
        clientsText,
      },
      requestsByTimeOptions: {
        responsive: true,
        plugins: {
          legend: {
            display: true,
          },
          title: {
            display: false,
            text: "Monthly Sales",
          },
        },
        scales: {
          y: {
            beginAtZero: true,
          },
        },
        defaultParams: defaultRequestsByClientOptionsParams,
      },
      requestsByClientOptions: {
        responsive: true,
        plugins: {
          legend: {
            position: "bottom",
          },
          title: {
            display: false,
            text: "Doughnut Chart Example",
          },
        },
        defaultParams: defaultRequestsByClientOptionsParams,
      },
      requestsByDestinationOptions: {
        responsive: true,
        scales: {
          x: {
            beginAtZero: true, // Ensures bars start from zero
          },
        },
        plugins: {
          legend: {
            position: "bottom", // Positions the legend at the top
          },
          title: {
            display: false,
            text: "Requests by Destinations", // Title of the chart
          },
        },
        defaultParams: defaultRequestsByClientOptionsParams,
      },
      requestsByStageOptions: {
        responsive: true,
        scales: {
          x: {
            beginAtZero: true, // Ensures bars start from zero
          },
        },
        plugins: {
          legend: {
            position: "bottom", // Positions the legend at the top
          },
          title: {
            display: false,
            text: "Requests by Stage", // Title of the chart
          },
        },
        loading: false,
        defaultParams: defaultRequestsByClientOptionsParams,
      },
      loading: true,
      dateToStringOptions: {
        weekday: "long",
        year: "numeric",
        month: "long",
        day: "numeric",
      },
      selectedChart: null,
      selectedSourceData: null,
      selectedSourceDataColumns: null,
      isSourceDataModalOpen: false,
      areReportsloading: false,
    };
  },
  computed: {
    ...mapGetters({
      authData: "auth/getAuthData",
      requestsByTime: "reports/getQuotesByTime",
      requestsByClients: "reports/getQuotesByClients",
      requestsByStage: "reports/getRequestsByStages",
      requestsByDestinations: "reports/getRequestsByDestinations",
      salesReport: "reports/getSalesReport",
      userSummary: "reports/getUserSummary",
      clients: "client/getClients",
      authUser: "auth/getAuthUserData",
      users: "users/getUsers",
    }),
  },
  methods: {
    closeModal() {
      this.isSourceDataModalOpen = false;
    },
  },
};
</script>
